import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIMenuContainerComponent } from './ui-menu-container.component';

@NgModule({
  declarations: [UIMenuContainerComponent],
  exports: [UIMenuContainerComponent],
  imports: [
    CommonModule
  ]
})
export class UIMenuContainerModule { }
